import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import type { AxiosError, AxiosResponse } from 'axios'
import axios from 'axios'
import qs from 'qs'

import type { StrapiArrayResponse, StrapiError } from '@/types/common/api'

import { envUtils } from '../envUtils'
const getBaseURL = () => {
  if (envUtils.localStrapiApiUrl) {
    return envUtils.localStrapiApiUrl
  }

  // hcms는 구축 공수가 많이 들어 매쓰플랫 도메인으로 일단 같이 사용
  if (envUtils.isLive) {
    return `https://hcms.mathflat.com/api`
  }
  return `https://hcms-staging.mathflat.com/api`
}

const strapi = axios.create({
  baseURL: getBaseURL(),
  params: {
    populate: '*',
  },
  paramsSerializer: (params) => qs.stringify(params),
})

strapi.interceptors.request.use((config) => {
  if (config.url?.match(/\?/g)) {
    throw Error('url에 parameter string넣지 말아주세요.')
  }

  return config
})

strapi.interceptors.response.use(
  (response: AxiosResponse<StrapiArrayResponse<any>>) => {
    return response
  },
  (error: AxiosError<StrapiError>) => {
    return Promise.reject(error)
  },
)

export default strapi
